import { Link } from "react-router-dom";
import { SiMeta } from "react-icons/si";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

function Footer() {
  return (
    <footer className="bg-envolvlyGray p-4 sm:p-6">
      <div className="md:flex md:justify-between">
        <div className="mb-6 md:mb-0">
          <Link to="/" className="flex items-center">
            <svg
              width="32"
              height="32"
              viewBox="0 0 900 900"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="30"
                y="30"
                width="839"
                height="839"
                rx="100"
                fill="#040410"
              />
              <rect
                x="216"
                y="132"
                width="454.747"
                height="152.588"
                fill="#6CF9A9"
              />
              <rect
                x="216"
                y="370.23"
                width="358.852"
                height="140.525"
                fill="#6CF9A9"
              />
              <rect
                x="397.537"
                y="590.366"
                width="209.28"
                height="162.84"
                fill="#6CF9A9"
              />
              <rect
                x="216"
                y="284.588"
                width="148.366"
                height="279.844"
                fill="#6CF9A9"
              />
              <ellipse
                cx="405.981"
                cy="556.591"
                rx="189.981"
                ry="196.615"
                fill="#6CF9A9"
              />
              <rect
                x="364.366"
                y="510.755"
                width="446.907"
                height="85.642"
                fill="#040410"
              />
              <rect
                x="364.366"
                y="284.588"
                width="446.907"
                height="85.642"
                fill="#040410"
              />
              <rect
                x="574.852"
                y="355.152"
                width="261.148"
                height="241.245"
                fill="#040410"
              />
              <path
                d="M591.655 744.893C597.427 756.193 613.573 756.193 619.345 744.893L683.583 619.117C688.865 608.773 681.353 596.5 669.738 596.5H541.262C529.647 596.5 522.135 608.773 527.417 619.117L591.655 744.893Z"
                fill="#6CF9A9"
              />
            </svg>
            <span className="self-center text-2xl font-semibold whitespace-nowrap text-white">
              Envolvly
            </span>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
          <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase text-white">
              Info
            </h2>
            <ul className="text-gray-600 text-gray-400">
              <li className="mb-4">
                <Link to="/about" className="hover:underline">About us</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:underline">Contact Us</Link>
                {" "}
                {/* MAKE IT REDIRECT TO COMPONENT USING CONTACT US */}
              </li>
            </ul>
          </div>
          <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase text-white">
              Follow us
            </h2>
            <ul className="text-gray-600 text-gray-400">
              <li className="mb-4">
                {/* MAKE IT REDIRECT TO COMPONENT USING CONTACT US */}
              </li>
              <li>
                <Link to="#" className="hover:underline">Discord</Link>
                {" "}
                {/* TODO: MAKE IT REDIRECT TO A LIVE COMMUNITY DISCORD */}
              </li>
            </ul>
          </div>
          <div>
            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase text-white">
              Legal
            </h2>
            <ul className="text-gray-600 text-gray-400">
              <li className="mb-4">
                <Link to="/privacy-policy" className="hover:underline">Privacy Policy</Link>
                {" "}
              </li>
              <li>
                <Link to="/terms-and-conditions" className="hover:underline">Terms & Conditions</Link>
                {" "}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <hr className="my-6 border-gray-200 sm:mx-auto border-gray-700 lg:my-8" />
      <div className="sm:flex sm:items-center sm:justify-between">
        <span className="text-sm text-gray-500 sm:text-center text-gray-400">
          © 2025{" "}
          <a href="https://www.envolvly.com/" className="hover:underline">
            Envolvly™
          </a>
          . All Rights Reserved.
        </span>
        <div className="flex mt-4 space-x-6 sm:justify-center sm:mt-0">
          <a
            href="https://facebook.com/envolvly"
            className="text-gray-500 hover:text-gray-900 hover:text-white"
          >
            <SiMeta className="w-5 h-5" />
            <span className="sr-only">Meta page</span>
          </a>
          <a
            href="https://instagram.com/envolvly"
            className="text-gray-500 hover:text-gray-900 hover:text-white"
          >
            <FaInstagram className="w-5 h-5" />
            <span className="sr-only">Instagram page</span>
          </a>
          <a
            href="https://twitter.com"
            className="text-gray-500 hover:text-gray-900 hover:text-white"
          >
            <FaXTwitter className="w-5 h-5" />
            <span className="sr-only">X page</span>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;